.accordionSummaryGroup {
  --ixf-accordion-header-background: var(--ixf-color-neutral-xlt);

  &.variant {
    &-onNeutral {
      --ixf-accordion-header-background: var(--ixf-color-background);
    }
  }
}
